function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { GenericThumbnailManager } from './generic-thumbnail-manager';
import { ShakaThumbnailProvider } from './shaka-thumbnail-provider';
export var ShakaThumbnailManager = /*#__PURE__*/ function(GenericThumbnailManager) {
    "use strict";
    _inherits(ShakaThumbnailManager, GenericThumbnailManager);
    function ShakaThumbnailManager(thumbnailConfig) {
        _class_call_check(this, ShakaThumbnailManager);
        var _this;
        var shakaThumbnailProvider = new ShakaThumbnailProvider();
        _this = _call_super(this, ShakaThumbnailManager, [
            shakaThumbnailProvider,
            thumbnailConfig
        ]), _define_property(_this, "shakaThumbnailProvider", void 0);
        _this.shakaThumbnailProvider = shakaThumbnailProvider;
        _this.isLive = shakaThumbnailProvider.isLive;
        return _this;
    }
    _create_class(ShakaThumbnailManager, [
        {
            key: "providePlayer",
            value: function providePlayer(player) {
                this.shakaThumbnailProvider.providePlayer(player);
            }
        },
        {
            key: "handleLoaded",
            value: function handleLoaded() {
                this.shakaThumbnailProvider.setThumbnailVariants();
                this.handleThumbnailVariantsInfoAvailable();
            }
        }
    ]);
    return ShakaThumbnailManager;
}(GenericThumbnailManager);

//# sourceMappingURL=shaka-thumbnail-manager.js.map